<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M13 12.4029C16.1 12.4029 18.7 9.9029 18.7 6.7029C18.7 3.6029 16.2 1.0029 13 1.0029C9.79995 0.902898
    7.19995 3.4029 7.19995 6.6029C7.19995 9.8029 9.79995 12.4029 13 12.4029Z"
    fill="#748097"
  />
  <path
    d="M10.2 22.6028C10.2 19.2028 12 16.3028 14.7 14.6028H8.7C4.9 14.6028 2 17.6028 2 21.3028V23.9028C2
    24.5028 2.4 24.9028 3 24.9028H10.6C10.3 24.2028 10.2 23.4028 10.2 22.6028Z"
    fill="#748097"
  />
  <path
    d="M21.1999 14.9028C16.6982 14.9028 12.8999 18.5605 12.8999 23.2028C12.8999 27.8452 16.5575 31.5028 21.1999
    31.5028C25.8423 31.5028 29.4999 27.8452 29.4999 23.2028C29.4999 18.5605 25.8423 14.9028 21.1999 14.9028ZM23.8728
    21.374L23.3101 22.6401H19.6524C19.6524 22.7808 19.6524 23.0622 19.6524 23.2028C19.6524 23.3435 19.6524 23.6249
    19.6524 23.7655H24.0135L23.3101 24.891H19.9338C20.4965 26.1571 21.7626 26.8605 23.3101 26.8605C24.2948 26.8605
    25.1389 26.5791 25.7016 26.0164L26.6863 27.0011C25.8423 27.8452 24.5762 28.4079 23.3101 28.4079C21.0592 28.4079
    19.0897 27.0011 18.3863 24.891H15.7135L16.2762 23.7655H18.105C18.105 23.6249 18.105 23.3435 18.105 23.2028C18.105
    23.0622 18.105 22.7808 18.105 22.6401H15.7135L16.2762 21.374H18.2457C18.9491 19.4045 20.9185 17.8571 23.1694
    17.8571C24.4355 17.8571 25.7016 18.4198 26.6863 19.1232L25.7016 20.1079C24.9982 19.5452 24.1541 19.2638 23.3101
    19.2638C21.9033 19.2638 20.6372 20.1079 19.9338 21.2333H23.8728V21.374Z"
    fill="#009DD6"
  />
</svg>
